module.exports = __webpack_public_path__ + "img/domestic-2005-new-youth.6cbb2f03.jpg";